module.exports = __webpack_public_path__ + "static/media/DM.e791b00f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/DM.svg
// module id = 2140
// module chunks = 7